import { DashletSetting, DashletSettingLoadable } from '@models/index';
import { SelectItem } from '@models/index';

export class DashletSettingDropdown extends DashletSetting implements DashletSettingLoadable {
    items!: SelectItem[];

    private loadingSem = 0;

    private pValue!: string | null;
    get value(): string | null {
        return this.pValue;
    }
    set value(value: string | null) {
        this.pValue = value;
        // clear loading items if selection changes
        if (this.pLoadingItem && value !== this.pLoadingItem.value) {
            this.pLoadingItem = null;
        }
    }

    private pLoadingItem!: SelectItem | null;
    get loadingItem(): SelectItem | null {
        return this.pLoadingItem;
    }

    getLoading() {
        return this.loadingSem > 0;
    }

    loadingBegin() {
        this.loadingSem++;
    }

    loadingComplete() {
        if (this.loadingSem > 0) {
            this.loadingSem--;
        }
        if (this.items?.length === 1 && !this.value) {
            this.value = this.items[0].value;
            this.change.next(null);
        }
    }

    loadState(obj: { [key: string]: any }): void {
        this.pLoadingItem = obj[this.stateKey];
        this.pValue = this.pLoadingItem ? this.loadingItem!.value : null;
    }

    saveState(obj: { [key: string]: any }): void {
        obj[this.stateKey] = this.getSelectedItem();
    }

    clear(): void {
        this.items = [];
        this.value = '';
    }

    private getSelectedItem(): SelectItem | null {
        // check for null selections
        if (this.value === '') {
            return null;
        }
        if (typeof this.value === 'string' && this.value.trim() === '') {
            return null;
        }

        // find item from value
        let item: SelectItem | null | undefined = null;
        if (this.items && this.items !== null) {
            item = this.items.find(item => item.value === this.value);
        }
        if (item === null && this.loadingItem?.value === this.value) {
            item = this.loadingItem;
        }

        // create default item if cannot find item
        if (item === null) {
            item = { label: 'Unknown', value: this.value! };
        }
        return item!;
    }
}
